const phrase = "Brand Architecture — Creative Direction — Design — Editorial Worlds — The Danielle Edit — ";

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="relative overflow-hidden border-y border-charcoal/10 bg-bone py-5 md:py-7 select-none"
  >
    <div className="flex whitespace-nowrap animate-marquee w-max">
      {[0, 1].map((copy) => (
        <span
          key={copy}
          className="font-serif italic text-2xl md:text-4xl text-charcoal/25 pr-2"
        >
          {phrase.repeat(3)}
        </span>
      ))}
    </div>
  </div>
);
